module.exports = __webpack_public_path__ + "small-left.svg";


//////////////////
// WEBPACK FOOTER
// ./~/ag-grid/src/styles/material-icons/small-left.svg?color1=%23333333&color2=
// module id = 2212
// module chunks = 67